import { makeStyles } from 'tss-react/mui';

const useStylesTableBody: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableBodyHidden: {
    display: 'none !important',
  },
  tableBodyPlain: {
    wordBreak: 'break-word',
    '& > tr > td': {
      padding: 10,
      '&:first-of-type': {
        paddingLeft: 16,
      },
      '&:last-of-type': {
        paddingRight: 16,
      },
    },
  },
  tableBodyNoBorders: {
    '& > tr > td': {
      border: 'none',
    },
  },
  tableBodyNoLastBorder: {
    '& > tr:last-of-type > td': {
      border: 'none',
    },
  },
  tableBodyZebraRows: {
    '& > tr': {
      backgroundColor: theme.palette.background.default,
      '&:nth-of-type(even)': {
        backgroundColor: theme.palette.primary.light,
      },
    },
  },
  tableBodyHeaderColumn: {
    '& > tr > td:nth-of-type(1)': {
      fontWeight: 500,
      wordBreak: 'break-word',
    },
  },
  tableBodyTwoColumns: {
    '& > tr > td': {
      '&:first-of-type': {
        width: '30%',
        minWidth: 100,
        [theme.breakpoints.down('sm')]: {
          width: '40%',
        },
      },
      '&:last-of-type': {
        width: '70%',
        [theme.breakpoints.down('sm')]: {
          width: '60%',
        },
      },
    },
  },
  tableBodyTwoEqualColumns: {
    '& > tr > td': {
      width: '50%',
    },
  },
  tableBodyFixedCellsSize: {
    '& > tr > td': {
      minWidth: 150,
    },
  },
  tableBodyFixedCellsSizeExtended: {
    '& > tr > td': {
      minWidth: 400,
    },
  },
  tableBodyFixedCellsSizeCompressed: {
    '& > tr > td': {
      minWidth: 120,
    },
  },
  tableBodySmallPadding: {
    '& > tr > td': {
      padding: '10px 5px',
    },
  },
  tableBodyBorderedCells: {
    '& > tr > td': {
      borderRight: `1px solid ${theme.palette.info.main}`,
      '&:last-of-type': {
        borderRight: 'none !important',
      },
    },
  },
  tableBodyAllBorderedCells: {
    '& > tr > td': {
      border: `1px solid ${theme.palette.info.main}`,
    },
  },
  tableBodyBorderedRows: {
    '& > tr': {
      border: `1px solid ${theme.palette.info.main}`,
    },
  },
  tableBodyTopBorder: {
    borderTop: `1px solid ${theme.palette.info.main}`,
  },
  tableBodyTopAlign: {
    '& > tr > td': {
      verticalAlign: 'top',
    },
  },
  tableBodyBlockCells: {
    '& > tr > td': {
      display: 'block',
    },
  },
}));

export default useStylesTableBody;
